import React from 'react';
import AdminServicesPage from './AdminServicesPage';

const AdminSubscriptionsPage = () => (
  <AdminServicesPage
    fixedCategory="Subscription"
    title="Подписки"
    subtitle="Отдельное управление подписочными товарами"
  />
);

export default AdminSubscriptionsPage;
